// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__zKMzj","loader":"Spinner_loader__SZx6k","load8":"Spinner_load8__ErTOC","spinnerText":"Spinner_spinnerText__DO6wW"};